// Chart APIs params

export interface IGetPriceLadderParams {
  symbol: string;
}
export interface IGetChartParams {
  symbol: string;
  period: EChartPeriod;
  from: number;
  to: number;
}

// Chart APIs response
export interface IPriceLadder {
  symbol: string;
  asks: IPriceLadderData[];
  bids: IPriceLadderData[];
}

export interface IPriceLadderData {
  position: number;
  price: number;
  size: number;
}

/** Chart API response */
export enum EChartPeriod {
  PERIOD_M1 = 1,
  PERIOD_M2 = 2,
  PERIOD_M3 = 3,
  PERIOD_M4 = 4,
  PERIOD_M5 = 5,
  PERIOD_M6 = 6,
  PERIOD_M10 = 10,
  PERIOD_M15 = 15,
  PERIOD_M20 = 20,
  PERIOD_M30 = 30,
  PERIOD_H1 = 60,
  PERIOD_H2 = 120,
  PERIOD_H3 = 180,
  PERIOD_H4 = 240,
  PERIOD_H6 = 360,
  PERIOD_H8 = 480,
  PERIOD_H12 = 720,
  PERIOD_D1 = 1440,
  PERIOD_W1 = 10080,
  PERIOD_MN1 = 43200
}

export const MINUTES_SPAN_PERIODS = [
  EChartPeriod.PERIOD_M1,
  EChartPeriod.PERIOD_M2,
  EChartPeriod.PERIOD_M3,
  EChartPeriod.PERIOD_M4,
  EChartPeriod.PERIOD_M5,
  EChartPeriod.PERIOD_M6,
  EChartPeriod.PERIOD_M10,
  EChartPeriod.PERIOD_M15,
  EChartPeriod.PERIOD_M20,
  EChartPeriod.PERIOD_M30
];

export const HOURS_SPAN_PERIODS = [
  EChartPeriod.PERIOD_H1,
  EChartPeriod.PERIOD_H2,
  EChartPeriod.PERIOD_H3,
  EChartPeriod.PERIOD_H4,
  EChartPeriod.PERIOD_H6
];

export const DAYS_SPAN_PERIODS = [EChartPeriod.PERIOD_D1, EChartPeriod.PERIOD_W1];

export const MONTHS_SPAN_PERIODS = [EChartPeriod.PERIOD_MN1];

export interface IMarketChartData {
  low: number;
  high: number;
  open: number;
  close: number;
  chartTime: number;
  ask?: number;
}

export interface IGetMarketChartsParams {
  from: number;
  to: number;
  symbol: string;
  period: EChartPeriod;
}

export interface IGetMarketLiveChartsParams {
  to: number;
  symbol: string;
  period: EChartPeriod;
}

export interface ILatestChartTime {
  chartTime: number;
  ask: number;
  bid: number;
}

export interface IGetMarketChartLatestParams {
  symbol: string;
  period: EChartPeriod;
}
